module.exports = __webpack_public_path__ + "img/information.c0e7bdc8.svg";